import React from "react";
import { Row, Col, Card, CardBody, Container } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// Charts
import IndusBenchMark2 from "pages/AllCharts2/echart2/IndusBenchMark2";
import CreditorsDay2 from "pages/AllCharts2/echart2/CreditorsDay2";
import DebtCredt2 from "pages/AllCharts2/echart2/DebtCredt2";
import RevnewProfit2 from "pages/AllCharts2/echart2/RevnewProfit2";
import DebtorsDay2 from "pages/AllCharts2/echart2/DebtorsDay2";
import CashFlowIndi2 from "pages/AllCharts2/echart2/CashFlowIndi2";

const EChart2 = () => {
  document.title = "ECharts | Bvo -Dashboard";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          {/* Render Breadcrumb */}
          <Breadcrumbs maintitle="Bvo" title="Charts" breadcrumbItem="ECharts" />

          <Row>
            <Col lg="6">
              <Card>
                <CardBody>
                  {/* <h4 className="mt-0 header-title mb-4">Industrial Benchmark Indicators</h4> */}
                  <div id="bubble-chart" className="e-chart">
                    <IndusBenchMark2 />
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col lg="6">
              <Card>
                <CardBody>
                  <h4 className="mt-0 header-title mb-4">Creditors Day</h4>
                  <div id="mix-line-bar" className="e-chart">
                    <CreditorsDay2 />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col lg="6">
              <Card>
                <CardBody>
                  <h4 className="mt-0 header-title mb-4">Debitors and Creditors</h4>
                  <div id="Debtors and Creditors" className="e-chart">
                    <DebtCredt2 />
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg="6">
              <Card>
                <CardBody>
                  <h4 className="mt-0 header-title mb-4">Revenew and Profit</h4>
                  <div id="DebetorsDayOutStanding" className="e-chart">
                    <RevnewProfit2/>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>

            <Col lg="6">
              <Card>
                <CardBody>
                  <h4 className="mt-0 header-title mb-4">Debtors Day</h4>
                  <div id="line-chart" className="e-chart">
                    <DebtorsDay2/>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg="6">
              <Card>
                <CardBody>
                  <h4 className="mt-0 header-title mb-4">Cash flow Indicators</h4>
                  <div id="mix-line-bar" className="e-chart">
                    <CashFlowIndi2/>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col lg="6">
              <Card>
                <CardBody>
                  <h4 className="mt-0 header-title mb-4">Profit Data Over Time</h4>
                  <div id="doughnut-chart" className="e-chart">
                    <RevnewProfit2/>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg="6">
              <Card>
                <CardBody>
                  <h4 className="mt-0 header-title mb-4">Working Capital</h4>
                  <div id="doughnut-chart" className="e-chart">
                    <WorkingCapitalChart2/>
                  </div>
                </CardBody>
              </Card>
            </Col>

          </Row>


        </Container>
      </div>
    </React.Fragment>
  );
};

export default EChart2;
